import persistedState from './persisted-state'

export default [persistedState]
